<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-8 col-sm-12">
          <div class="element-box mb-0">
            <h5 class="form-header">
              Generar etiquetas de referencia para facturas
            </h5>
            <div class="row">
              <div class="col-md-12">
                <label>Cantidad de etiquetas</label>
                <input
                  type="text"
                  class="form-control text-center"
                  v-model="current.cantidad"
                />
              </div>
              <div class="col-sm-12">
                <br />
                <button
                  @click="GenerarReporte(current)"
                  class="btn btn-block btn-dark btn-md"
                >
                  Imprimir Etiquetas
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      current: {
        cantidad: 1,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    GenerarReporte(current) {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=wms/BarrasReferenciasFacturas.jrxml&cantidad=${current.cantidad}`
      );
      this.current.cantidad = 1;
    },
  },
};
</script>
